import { ProductStateInterface } from "./types";
import Product from "@/types/app/products";
export default {
 
  getProductSent(state: ProductStateInterface): boolean {
    return state.productSent;
  },
  getProductsState(state: ProductStateInterface): Product[] {
    return state.products;
  },
  getProductById: (state: ProductStateInterface)=> (id:string) => { 
    return state.products.find(x => x.id == id);
  },

  getOnlyPublished(state: ProductStateInterface) : Product[]{
    return state.products.filter(x => x.published);
  }
 
};
